<template>
  <div>
    <h1 class="mb-4 text-center">Rewards</h1>
    <div class="flex justify-between items-center">
      <BaseLink
        :link="{ name: 'AddReward' }"
        class="bg-green text-white px-4 py-2 add-btn"
        >Create New Reward</BaseLink
      >
    </div>
    <Table ref="table" :endpoint="endpoint" :tableConfig="config" class="mt-8">
      <template #row="{row}">
        <td>{{ row.name }}</td>
        <td>{{ row.max_redemption_count }}</td>
        <td>{{ row.xp_points }}</td>
        <td>{{ row.stock }}</td>
        <td>
          <BaseLink
            :title="row.typeform_url"
            :link="row.typeform_url"
            class="text-blue text-center inline-block h-6 w-6 hover:bg-grey-light active:bg-grey-light focus:bg-grey-light"
            ><span class="material-icons">
              open_in_new
            </span></BaseLink
          >
        </td>
        <td>
          <router-link
            :to="{ name: 'EditReward', params: { id: row.id } }"
            class="w-6 h-6 inline-block hover:bg-grey-light flex justify-center items-center no-underline"
          >
            <i class="material-icons text-xl">edit</i>
          </router-link>
        </td>
        <td class="text-center">
          <button
            class="w-6 h-6 rounded-none flex justify-center items-center hover:bg-grey-light active:bg-grey-light focus:bg-grey-light"
            @click="deleteItem(row)"
          >
            <i class="material-icons text-2xl text-red">delete_forever</i>
          </button>
        </td>
      </template>
    </Table>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import BaseLink from "@/components/Base/BaseLink"
import Table from "@/components/DataTable/Table"
import { deleteReward } from "@/apis/rewards"
import formUtilMixin from "@/mixins/formUtilMixin"

export default {
  components: { BaseLink, Table },
  mixins: [formUtilMixin],
  data() {
    return {
      config: [
        { header: { textContent: "Name", sortingParam: "name" } },
        "Max Redemption",
        "XP Points",
        "Stock Left",
        "Type Form",
        "Edit",
        "Delete",
      ],
    }
  },
  computed: {
    endpoint: () => `${siteConfig.siteURL}admin/rewards`,
  },
  methods: {
    async deleteItem({ id, name }) {
      if (
        !(await this.confirmDelete(`Are you sure you want to delete ${name}?`))
      )
        return
      deleteReward(id)
        .then(() => {
          this.$noty.success(`Successfully deleted ${name}`)
          this.$refs.table.getItems()
        })
        .catch(err => {
          console.error(err)
          const msg =
            err.response && err.response.data
              ? this.$options.filters.capitalize(err.response.data.message)
              : `Failed to delete ${name}`
          this.$swal({
            text: msg,
            icon: "warning",
            buttons: "Close",
          })
        })
    },
  },
}
</script>

<style scoped>
.add-btn {
  color: #fff;
}
</style>
